import { useMemo } from 'react';

import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core';

import useMultipleEmployerIdsFeatureFlag from './useMultipleEmployerIdsFeatureFlag';

const useMultipleEmployerSelectAvailable = () => {
  const isMultipleEmployerAvailable = useMultipleEmployerIdsFeatureFlag();
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();
  const isPartnerOrDistributor = useMemo(() => {
    return type === OrganizationTypes.partner || type === OrganizationTypes.distributor;
  }, [type]);

  return isMultipleEmployerAvailable && !!isPartnerOrDistributor;
};

export default useMultipleEmployerSelectAvailable;
